import type { ContentObjectDetail, ContentObjectList } from 'models';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { Button, RepeatLine } from 'ui';
import { RepostModal } from './repost-modal';

type P = {
  item: ContentObjectDetail | ContentObjectList;
  preview: ReactNode;
};

const RepostButton = ({ item, preview }: P) => {
  const [isRepostOpen, setIsRepostOpen] = useState(false);

  return (
    <div>
      <Button
        icon={<RepeatLine />}
        onClick={() => {
          setIsRepostOpen(true);
        }}
        size="large"
        type="text"
      >
        Repost
      </Button>
      <RepostModal
        isOpened={isRepostOpen}
        item={item}
        onCancel={() => {
          setIsRepostOpen(false);
        }}
        preview={preview}
      />
    </div>
  );
};

export default RepostButton;
